import { Box, Container, Typography, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSWR, { useSWRConfig } from 'swr';
import useAuthStore from '../../store/zustand/auth';
import Api from '../../api';
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage
} from '../../utils/authHelper';
import { loginLandingByRole } from '../../helpers/routesConstants';
import { priorityRoleLogin } from '../../helpers/roles';

interface Props {
  isMobile: boolean;
  setCurrentProcess: React.Dispatch<React.SetStateAction<string>>;
}

const Impersonate: React.FC<Props> = function Impersonate({
  isMobile,
  setCurrentProcess
}) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const userState = useAuthStore((state) => state);
  const [error, setError] = useState<boolean>(false);
  const [fireProfile, setFireProfile] = useState<boolean>(false);
  const { mutate } = useSWRConfig();

  // ======================================== API

  const {
    data: profile,
    isValidating: isValidatingProfile,
    error: errorProfile
  } = useSWR(fireProfile ? 'api/profile' : null, Api.authApi.getProfile);

  const clearCache = () => mutate(null, true);
  const clearProfile = () => mutate('api/profile', null, true);
  const clearCompany = () => mutate('api/currentCompany', null, true);

  const loginValidation = (profile: any) => {
    const role = priorityRoleLogin(
      profile?.roles?.map((item: any) => item.name),
      true
    );
    if (profile && profile.email) {
      if (false || profile.block) {
        // if (!profile.active || profile.block) { // validation to be defined
        // attempt
        setError(true);
        setFireProfile(false);
      } else {
        userState.login();
        if (profile.mfa) {
          setCurrentProcess('mfa');
        } else {
          navigate(
            loginLandingByRole[role as keyof typeof loginLandingByRole],
            {
              replace: true
            }
          );
        }
      }
    }
  };

  useEffect(() => {
    if (profile) {
      const {
        roles,
        email,
        mfa,
        block,
        active,
        firstName,
        lastName,
        skills,
        phoneNumber,
        id,
        timeFormat,
        company
      } = profile;
      const { plan } = company;
      const rolesName = roles.map((ele: any) => ele.name);
      const skillsName = skills.map((ele: any) => ele.name);
      userState.setUser({
        active,
        block,
        email,
        firstName,
        id,
        lastName,
        mfa,
        phoneNumber,
        plan,
        roles: rolesName,
        skills: skillsName,
        timeFormat
      });
      loginValidation(profile);
    }
  }, [profile]);

  useEffect(() => {
    const oldToken = getLocalStorage('accessToken');
    if (state?.token) {
      clearProfile();
      clearCache();
      clearCompany();
      if (!state?.isGoingBack && state.token !== oldToken) {
        removeLocalStorage('accessTokenImpersonate');
        setLocalStorage('accessTokenImpersonate', oldToken);
      }
      if (state?.isGoingBack) {
        removeLocalStorage('accessTokenImpersonate');
      }
      removeLocalStorage('accessToken');
      setLocalStorage('accessToken', state?.token);
      if (state.requestTwoFactor) {
        setCurrentProcess('mfa');
      } else {
        setFireProfile(true);
      }
    }
  }, [state]);

  useEffect(() => {
    if (errorProfile) {
      setError(true);
    }
  }, [errorProfile]);

  return (
    <Box
      sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
    >
      <CircularProgress size={40} />
    </Box>
  );
};

export default Impersonate;
